import React from "react";
import { SunScrollProvider } from "../context/SunScrollContext";
import MainScrollContent from "./MainScroll";
import "./MainPage.css";

const MainPage = () => {
	return (
		<div className="animation">
			<SunScrollProvider>
				<MainScrollContent />
			</SunScrollProvider>
		</div>
	);
};

export default MainPage;
